import styled from "styled-components";

export const GlassButton = styled.button`
  display: inline-flex; 
  align-items: center; 
  gap: .5rem;
  padding: .9rem 1.2rem; 
  border-radius: 999px; 
  border: 1px solid rgba(255,255,255,.35);
  background: linear-gradient(90deg, ${({theme})=>theme.colors.gradient.from} 0%, ${({theme})=>theme.colors.gradient.to} 100%);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 24px rgba(0,0,0,.12);
  font-weight: 700; 
  letter-spacing: .2px; 
  cursor: pointer;
  color: ${({theme})=>theme.colors.text.white};
  transition: transform .12s ease, box-shadow .2s ease, background .2s ease;
  min-height: 44px;
  min-width: 44px;
  
  /* Pulsing animation */
  animation: pulse 2s ease-in-out infinite;
  
  &:hover { 
    transform: translateY(-1px); 
    box-shadow: 0 12px 28px rgba(0,0,0,.18); 
    background: linear-gradient(90deg, ${({theme})=>theme.colors.gradient.to} 0%, ${({theme})=>theme.colors.gradient.from} 100%);
    animation: none; /* Stop pulsing on hover */
  }
  
  &:active { 
    transform: translateY(0); 
  }

  @media (max-width: ${({theme})=>theme.breakpoints.sm}) {
    min-height: 40px;
    min-width: 40px;
    padding: .75rem 1rem;
  }
  
  @keyframes pulse {
    0% {
      box-shadow: 0 8px 24px rgba(0,0,0,.12);
      transform: scale(1);
    }
    50% {
      box-shadow: 0 8px 24px rgba(0,0,0,.12), 0 0 0 0 rgba(92, 158, 173, 0.7);
      transform: scale(1.02);
    }
    100% {
      box-shadow: 0 8px 24px rgba(0,0,0,.12);
      transform: scale(1);
    }
  }
`;

export const Gradient = styled.div`
  background: radial-gradient(1200px 600px at 10% -10%, rgba(255,255,255,.20) 0%, rgba(255,255,255,0) 60%),
              linear-gradient(90deg, ${({theme})=>theme.colors.gradient.from} 0%, ${({theme})=>theme.colors.gradient.to} 100%);
`;

export const GlassCard = styled.div`
  background: rgba(255,255,255,.16);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,.35);
  border-radius: ${({theme})=>theme.borderRadius.xl};
  box-shadow: 0 8px 24px rgba(0,0,0,.12);
  padding: ${({theme})=>theme.spacing[6]};
  transition: all ${({theme})=>theme.transitions.normal};
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0,0,0,.18);
    background: rgba(255,255,255,.22);
  }

  @media (max-width: ${({theme})=>theme.breakpoints.sm}) {
    padding: ${({theme})=>theme.spacing[4]};
  }
`;

export const GlassInput = styled.input`
  background: rgba(255,255,255,.16);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,.35);
  border-radius: ${({theme})=>theme.borderRadius.lg};
  padding: ${({theme})=>theme.spacing[3]} ${({theme})=>theme.spacing[4]};
  color: ${({theme})=>theme.colors.text.white};
  font-size: ${({theme})=>theme.typography.fontSize.base};
  transition: all ${({theme})=>theme.transitions.fast};
  min-height: 44px;
  
  &::placeholder {
    color: rgba(255,255,255,.7);
  }
  
  &:focus {
    outline: none;
    border-color: rgba(255,255,255,.6);
    background: rgba(255,255,255,.22);
    box-shadow: 0 0 0 3px rgba(255,255,255,.1);
  }

  @media (max-width: ${({theme})=>theme.breakpoints.sm}) {
    font-size: 16px;
    min-height: 40px;
  }
`;

export const GlassContainer = styled.div`
  background: rgba(255,255,255,.08);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,.2);
  border-radius: ${({theme})=>theme.borderRadius.xl};
  padding: ${({theme})=>theme.spacing[6]};
  margin: ${({theme})=>theme.spacing[4]} 0;
  
  @media (max-width: ${({theme})=>theme.breakpoints.sm}) {
    padding: ${({theme})=>theme.spacing[4]};
    margin: ${({theme})=>theme.spacing[3]} 0;
  }
`;

export const FloatingGlassButton = styled(GlassButton)`
  position: fixed;
  bottom: ${({theme})=>theme.spacing[6]};
  right: ${({theme})=>theme.spacing[6]};
  z-index: ${({theme})=>theme.zIndex.floating};
  box-shadow: 0 8px 32px rgba(0,0,0,.2);
  
  @media (max-width: ${({theme})=>theme.breakpoints.sm}) {
    bottom: ${({theme})=>theme.spacing[4]};
    right: ${({theme})=>theme.spacing[4]};
  }
`;

export const GradientText = styled.span`
  background: linear-gradient(135deg, ${({theme})=>theme.colors.gradient.from} 0%, ${({theme})=>theme.colors.gradient.to} 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: ${({theme})=>theme.typography.fontWeight.bold};
`;

export const AnimatedGradient = styled.div`
  background: linear-gradient(-45deg, 
    ${({theme})=>theme.colors.gradient.from}, 
    ${({theme})=>theme.colors.gradient.to}, 
    ${({theme})=>theme.colors.gradient.mint}, 
    ${({theme})=>theme.colors.gradient.coral}
  );
  background-size: 400% 400%;
  animation: gradientShift 15s ease infinite;
  
  @keyframes gradientShift {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;
